import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";

const useUpdateGroup = () => {
  return useMutation((params) =>
    servicesUtils.postService("/accounts/groups/update", params)
  );
};

export default useUpdateGroup;
